import { UploadControlModeEnum } from '../types/templates';

interface IUseTemplateOverrideModeProps {
  mode: UploadControlModeEnum;
  overrideValue: string | number | object | undefined;
  onClearOverride?: () => void;
}

export const useTemplateOverrideMode = ({ mode, overrideValue, onClearOverride }: IUseTemplateOverrideModeProps) => {
  const isPageOverrideMode = mode === UploadControlModeEnum.PageOverride;
  const isOverridden = isPageOverrideMode && overrideValue !== undefined;
  const shouldClearOverride = isPageOverrideMode && isOverridden && !!onClearOverride;

  return {
    isPageOverrideMode,
    isOverridden,
    shouldClearOverride,
  };
};
